const LABELS = {
  TITLE: 'Eita!',
  SUBTITLE: 'Parece que você não tem acesso à essa área!',
  LOGOUT: 'Sair'
};

export default LABELS;
